export const formatCurrency = (amount) => {
    if (isNaN(amount)) {
        throw new Error('Invalid number');
    }

    if (amount === null || amount === undefined) {
        return '';
    }

    return `${Number(amount).toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })} ₺`;
};
